import {useRef} from 'react';

import {useScrollTilt} from '../../hooks/useScrollTilt.js';
import {AmbientVideo} from '../AmbientVideo/AmbientVideo.js';

import type {ReactElement} from 'react';

const scenes = [
  {caption: 'Characters go anywhere.', poster: new URL('../../assets/video/hero-scene-1.jpg', import.meta.url).href, title: 'Astronaut among the stars', video: new URL('../../assets/video/hero-scene-1.mp4', import.meta.url).href},
  {caption: 'Every expression tells a story.', poster: new URL('../../assets/video/hero-scene-2.jpg', import.meta.url).href, title: 'Creator presenting a fragrance', video: new URL('../../assets/video/hero-scene-2.mp4', import.meta.url).href},
  {caption: 'More than a moment.', poster: new URL('../../assets/video/hero-scene-3.jpg', import.meta.url).href, title: 'Two characters entering a futuristic facility', video: new URL('../../assets/video/hero-scene-3.mp4', import.meta.url).href}
];

export const SeedanceShowcase = (): ReactElement => {
  const panels = useRef<HTMLDivElement>(null);
  useScrollTilt(panels);
  return (
    <div aria-label="Creative possibilities in three videos" className="hero-floating-panels" ref={panels}>
      {scenes.map(({caption, poster, title, video}, index) => <figure className={`hero-floating-panel hero-floating-panel-${index + 1}`} data-scroll-tilt key={caption}><AmbientVideo poster={poster} src={video} title={title} /><figcaption>{caption}</figcaption></figure>)}
    </div>
  );
};
